import { SvgIcon, type SvgIconProps } from '@components/primitives/SvgIcon';

import Week from '../assets/icons/custom/Week.svg?react';

export function WeekIcon(props: SvgIconProps) {
  return <SvgIcon component={Week} inheritViewBox {...props} />;
}
